export const getReportPreviewVersion = (data: object | null | undefined) => {
  if (!data) {
    return '0';
  }

  const contentFingerprint = JSON.stringify(data, (key, value) => {
    // Timestamps and recreated junction IDs do not change rendered content.
    if (key === 'updated_at' || key === 'created_at' || key === 'id') {
      return undefined;
    }
    return value;
  });

  // djb2 hash — short string for use as the v= cache-buster param.
  let hash = 5381;
  for (let i = 0; i < contentFingerprint.length; i++) {
    hash = ((hash << 5) + hash + contentFingerprint.charCodeAt(i)) | 0;
  }
  return (hash >>> 0).toString(36);
};
